module.exports = __webpack_public_path__ + "static/media/arrow-right.72827362.svg";